export const experienceData = [
    {
        id: 1,
        company: 'Perseverer (Atlanta, GA, US)',
        jobtitle: 'Full-Stack Developer/ Instructor',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        company: "Seattle Children's Research Institute (Seattle, WA, US)",
        jobtitle: 'Research Assistant',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 3,
        company: 'AtomLeap (Berlin, Germany)',
        jobtitle: 'Data Science Intern',
        startYear: '2019',
        endYear: '2019'
    },
    {
        id: 3,
        company: 'Center for Infectious Disease Research (Seattle, WA, US)',
        jobtitle: 'Laboratory Assistant',
        startYear: '2017',
        endYear: '2018'
    },
    {
        id: 3,
        company: 'Pacific Science Center (Seattle, WA, US)',
        jobtitle: 'Interpretive Science Educator',
        startYear: '2012',
        endYear: '2018'
    },
]